export default __webpack_public_path__ + "static/media/amsterdam-1x.fe7a12bb.webp";